<template>
    <div style="margin: 20px;">
      <el-tabs v-model="activeName" type="card" style="margin: 0 40px 0 40px;">
        <el-tab-pane label="物流测试" name="wlset" style="margin: 0 20px 0 20px">
          <el-collapse v-model="activeSets" accordion>
            <el-collapse-item title="杭州开阳云仓" name="1" >
              <div style="display: flex; flex-direction: row;">
                <div>
                  <el-image
                    style="width: 90px; height: 90px; border-radius: 10px"
                    :src="jdimg"
                    :fit="contain"></el-image>
                </div>
                <div style="margin-left: 20px; border-left: 1px solid #ccc;">
                  <div style="margin-left: 20px;">
                    <div style="margin-top: 10px;">
                      <el-button type="success" style="margin-top: 15px;margin-left: 10px;" @click="runtest" size="small" plain>简单测试</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="orderimport" size="small" plain>订单导入</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="ordercancel" size="small" plain>订单取消</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="orderstatequery" size="small" plain>订单状态查询</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="fhquery" size="small" plain>发货查询</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="orderquery" size="small" plain>订单查询</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="stackquery" size="small" plain>轨迹查询</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; margin-top: 30px; display: flex; justify-content: center; align-items: center;">
                <json-viewer
                  :value="resultstr"
                  style="width: 100%; min-width: 3.125rem; "
                  :expand-depth="4"
                  expanded
                  copyable
                  boxed
                  sort
                ></json-viewer>
              </div>
            </el-collapse-item>
            <el-collapse-item title="聚水潭开放平台" name="2" >
              <div style="display: flex; flex-direction: row;">
                <div>
                  <el-image
                    style="width: 90px; height: 90px; border-radius: 10px"
                    :src="jstimg"
                    :fit="contain"></el-image>
                </div>
                <div style="margin-left: 20px; border-left: 1px solid #ccc;">
                  <div style="margin-left: 20px;">
                    <div style="margin-left: 10px;font-size: 14px;">
                      access_token: <span style="margin-left: 10px; color: darkgreen;">{{jstaccesstoken}}</span>
                    </div>
                    <div style="margin-top: 10px;">
                      <el-button type="success" style="margin-top: 15px;margin-left: 10px;" @click="shopquery" size="small" plain>店铺查询</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="kfquery" size="small" plain>库存查询</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="ordercreate" size="small" plain>订单下单</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="jstordercancel" size="small" plain>订单取消</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="jststackquery" size="small" plain>轨迹查询</el-button>
                      <el-button type="success" style="margin-top: 15px" @click="testgetztpos" size="small" plain>中通物流查询</el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; margin-top: 30px; display: flex; justify-content: center; align-items: center;">
                <json-viewer
                  :value="resultstr1"
                  style="width: 100%; min-width: 3.125rem; "
                  :expand-depth="4"
                  expanded
                  copyable
                  boxed
                  sort
                ></json-viewer>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
        <el-tab-pane label="配送订单" name="wlinfo">
          <el-collapse v-model="activeNames" style="border: none;">
            <el-collapse-item title="配送查询" name="1" style="margin: 0px 20px 0 20px;">
              <el-form :inline="true" label-width="110px" style="padding: 20px 0 0 0; border-top: 1px solid #f1f1f1;">
                <el-form-item label="订单号:" style="margin-left: 10px;">
                  <el-input v-model="order_no" placeholder="请输入订单号"></el-input>
                </el-form-item>
                <el-form-item label="订单日期:" style="margin-left: 10px;">
                  <el-date-picker
                    v-model="byorderdate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
                <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="queryorder">查 询</el-button>
              </el-form>
            </el-collapse-item>
          </el-collapse>
          <el-table
            stripe
            id="orderdataid"
            :header-cell-style="{'text-align':'center'}"
            :data="logisticsdata"
            ref="multipleTable">
            <el-table-column
              prop="order_no"
              width = "200px"
              label="订单编号">
            </el-table-column>
            <el-table-column
              prop="logisticsno"
              label="配送单号">
            </el-table-column>
            <el-table-column
              prop="threename"
              label="快递公司">
            </el-table-column>
            <el-table-column
              prop="lineno"
              label="ERP编号">
            </el-table-column>
            <el-table-column
              prop="op_time"
              label="下单时间">
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="查看物流信息" placement="top-start">
                  <i class="fa el-icon-position fa-lg ciicon curpointer" v-on:click="seejdorder(scope.$index, logisticsdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="同步到物流到微信" placement="top-start">
                  <i class="fa el-icon-upload2 fa-lg ciicon curpointer" v-on:click="syncordertowx(scope.$index, logisticsdata)"></i>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="取消订单" placement="top-start" :hidden="ifhiddenqueren">
                  <i class="fa el-icon-refresh-left fa-lg ciicon curpointer" v-on:click="canceljdorder(scope.$index, logisticsdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="发货信息" width="40%" :visible.sync="fhvisiable">
            <div class="showpcinfo">
              <el-timeline :reverse="reverse">
                <el-timeline-item
                  v-for="(activity, index) in wloplist"
                  :key="index">
                  <el-card>
                    <h5>{{activity.categoryName}}</h5>
                    <div style="display: flex; flex-direction: row;">{{activity.operatorName}} <div v-if="activity.operatorPhone !== undefined">({{activity.operatorPhone}})</div>  {{activity.operationRemark}} </div>
                    <div style="margin-top: 10px;">{{activity.operationTime}}</div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </el-dialog>
          <el-dialog title="物流轨迹信息" width="40%" :visible.sync="stackvisiable">
            <div style="width: 100%; margin-top: 30px; display: flex; justify-content: center; align-items: center;">
              <json-viewer
                :value="stackresult"
                style="width: 100%; min-width: 3.125rem; "
                :expand-depth="4"
                expanded
                copyable
                boxed
                sort
              ></json-viewer>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import JsonViewer from 'vue-json-viewer'
  Vue.use(JsonViewer)
  Vue.prototype.$http = axios
  var that
  export default {
    name: 'PSInfo',
    data () {
      return {
        activeName: 'wlset',
        order_no: '',
        stackvisiable: false,
        byorderdate: '',
        stackresult: '',
        reverse: '',
        wloplist: [],
        fhvisiable: false,
        resultstr: '返回结果呈现:',
        accesstoken: '698ba9dcbb044ec18d9e689736fbbee8',
        todate: '',
        logisticsdata: [],
        resultstr1: '返回结果呈现:',
        activeNames: ['1'],
        activeSets: ['2'],
        jstaccesstoken: '',
        curaccesstoken: '',
        jdimg: 'http://ecm.chlelem.com/themes/orange/images/clys_logo.png',
        jstimg: 'https://xymedia.qixincha.com/company_auth/4c700fb6bfef11ea8c580242ac110002.png'
      }
    },
    mounted () {
      that = this
      that.get1taoaccess()
      that.getminproaccess()
      // that.getaccessinfo()
    },
    methods: {
      getwllist () {
        var qdata = {
          access_token: that.curaccesstoken
        }
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/getwllist',
          method: 'post',
          data: qdata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getminproaccess () {
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/getdaccesstoken',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.curaccesstoken = res.data
            // that.getwllist()
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      seejstorder (index,data) {
        var tmpdata = data[index]
        var jsondata = {
          'shop_id': 15846245,
          'date_type': 0,
          'so_ids': [tmpdata.order_no],
          'page_index': 1,
          'page_size': 30
        }
        var qstr = {
          access_token: this.jstaccesstoken,
          param_json: JSON.stringify(jsondata),
          v_method: '/open/logistic/query',
          if_new: '1'
        }
        that.$http({
          url: 'http://localhost:5709/runjst',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      seejdorder (index,data) {
        that = this
        that.stackvisiable = true
        if (data[index].logisticsno !== null && data[index].logisticsno !== undefined && data[index].logisticsno !== '') {
          // that.stackquerybybase(data[index].logisticsno)
          that.getztpos(data[index].logisticsno)
        } else {
          that.orderquerybyorder(data[index].order_no)
        }
      },
      get1taoaccess () {
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/get1taoaccesstoken',
          method: 'get',
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.jstaccesstoken = res.data
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      testgetztpos () {
        var qstr = {
          wlorderno: '78780881816488',
          phoneno: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/gettrajectory',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(res.data.data)
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getztpos (pono) {
        var qstr = {
          wlorderno: pono,
          phoneno: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/gettrajectory',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.stackresult = JSON.parse(res.data.data)
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      querypos (jsondata) {
        that = this
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/getjdtrace',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.data.code === 0) {
              that.fhvisiable = true
              that.wloplist = res.data.data.data.traceDetails
            } else {
              that.$message.error('没有获取到物流信息')
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      syncordertowx (index,data) {
        var tmpdata = data[index]
        window.console.log(tmpdata)
        var date = new Date(tmpdata.op_time);
        var isotime = date.toISOString();
        var upata = {
          access_token: that.curaccesstoken,
          wldata: {
            order_key: {
              order_number_type: 2,
              transaction_id: tmpdata.wxpayno,
              out_trade_no: tmpdata.orderno,
              mchid: '1573495261'
            },
            delivery_mode: 1,
            logistics_type: 1,
            shipping_list: [
              {
                tracking_no: tmpdata.logisticsno,
                express_company: tmpdata.wxwlbz,
                item_desc: '黄小醺黄酒'
              }
            ],
            upload_time: isotime,
            payer: {
              openid:tmpdata.buy_cus_id
            }
          }
        }
        that.$http({
          url: 'https://wx.sqnetsoft.cn/wx/uploadShippingInfo',
          method: 'post',
          data: upata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            if (res.data.data.errcode === 0) {
              that.$message.success('同步成功')
            } else {
              that.$message.error('同步失败,' + res.data.data.errmsg)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      canceljdorder (index,data) {
        that = this
        that.ordercancelbyorder(data[index].order_no)
      },
      queryorder () {
        var qstr = ' state_id >=3 '
        if (this.order_no !== null && this.order_no !== '' && this.order_no !== 0) {
          qstr = qstr + " and order_no like '%" + this.order_no + "%'"
        }
        if (this.byorderdate !== null && this.byorderdate !== '') {
          qstr = qstr + " and op_time >= '" + this.byorderdate[0] + " 00:00:00' and op_time<='" + this.byorderdate[1] + " 23:59:59'"
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/queryorderlogistics',
          method: 'post',
          data: {
            whereinfo: qstr,
            limit: '',
            sortinfo: ' order by op_time desc'
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              window.console.log(res.data)
              that.logisticsdata = res.data
            } else {
              that.logisticsdata = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      stackquerybybase (psno) {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            out_sid: psno
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'expressTrack',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.stackresult = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      stackquery () {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            out_sid: '78735502291046'
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'expressTrack',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      shopquery() {
        var jsondata = {
          page_index: '1',
          page_size: '10',
          shop_ids: [
            '15830174','15829724'
          ]
        }
        var qstr = {
          access_token: this.jstaccesstoken,
          param_json: JSON.stringify(jsondata),
          v_method: '/open/shops/query',
          if_new: '1'
        }
        that.$http({
          url: 'http://localhost:5709/runjst',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      kfquery () {
        var jsondata = {
          page_index: '1',
          page_size: '10',
          sku_ids: '硕祺6974138790000,硕祺6974138790017,硕祺6974138790024,硕祺6974138790048'
        }
        var qstr = {
          access_token: this.jstaccesstoken,
          param_json: JSON.stringify(jsondata),
          v_method: '/open/inventory/query',
          if_new: '1'
        }
        that.$http({
          url: 'http://localhost:5709/runjst',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      ordercreate () {
        var jsondata = [
          {
            'shop_id':15846245,
            'so_id':'2022060601',
            'order_date':'2022-03-10 15:24:13',
            'shop_status':'1',
            'shop_buyer_id':'2022060601', //  购买人
            'receiver_state':'Kuala Lumpur', //  接收状态
            'receiver_city':'Kuala Lumpur', //  接收城市
            'receiver_district':'Kuala Lumpur', //  接收街道
            'receiver_address':'No 170 Jalan Sepakat 2 United Garden 58200 kl', // 地址
            'receiver_name':'Dorisneoh', // 收货人
            'receiver_phone':'0126692533', // 联系方式
            'receiver_zip':'58200', // 邮编
            'pay_amount':0, // 应付金额
            'freight':0, // 运费
            'remark':'KCL', // 备注
            'buyer_message':'KCL', //  购买信息
            'shop_modified':'', // 订单修改日期
            'l_id':'', // 快递单号
            'logistics_company':'', // 快递公司
            'labels':'',
            'lc_id':'OTHER',
            'items':[
              {
                'sku_id':'2021031920158541', // 产品ID
                'shop_sku_id':'2021031920158541', // SD
                'amount':0, // 多少件
                'base_price':0,
                'qty':2,
                'name':'测试品',
                'outer_oi_id':'443110',
                'batch_id': '17',
                'produced_date': '2022-08-19'
              }
            ]
          }
        ]
        var qstr = {
          access_token: this.jstaccesstoken,
          param_json: JSON.stringify(jsondata),
          v_method: '/open/jushuitan/orders/upload',
          if_new: '1'
        }
        that.$http({
          url: 'http://localhost:5709/runjst',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      jstordercancel () {
        var jsondata = {
          'o_ids': ['101104'],
          'remark': '',
          'cancel_type': '不需要了'
        }
        var qstr = {
          access_token: this.jstaccesstoken,
          param_json: JSON.stringify(jsondata),
          v_method: '/open/jushuitan/orderbyoid/cancel',
          if_new: '1'
        }
        that.$http({
          url: 'http://localhost:5709/runjst',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      jststackquery () {
        var jsondata = {
          'shop_id': 15846245,
          'date_type': 1,
          'so_ids': ['XS20240322162104oe7'],
          'page_index': 1,
          'page_size': 30
        }
        var qstr = {
          access_token: this.jstaccesstoken,
          param_json: JSON.stringify(jsondata),
          v_method: '/open/logistic/query',
          if_new: '1'
        }
        that.$http({
          url: 'http://localhost:5709/runjst',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr1 = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      runtest () {
        var jsondata = {
            begin_date: '2022-10-01 00:00:00',
            end_date: '2023-10-01 00:00:00',
            page_no: '1',
            page_size: '10',
            owner_id: '340120'
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'queryProducts',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log(res)
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      orderimport () {
        var jsondata = {
          count: 1, // 导入订单数
          trades:[
              {
                order_no: '10000000', // 导入订单号
                stock_id: '220126', // 网仓仓库Id
                transporter_flag: '0', // 是否已指定快递
                transporter_id: '',
                waybill_type:'',
                send_flag:'0', // 是否下发发货指令0否,1是
                shop_id: '254776', // 店铺ID
                order_create_time: '2023-10-10 00:00:00', // 拍单时间
                order_pay_time: '2023-10-10 00:00:00', // 付款时间
                buyer_nick:'1', // 买家昵称
                receiver_country:'中国', // 收货人国家
                receiver_province:'北京', // 省
                receiver_city:'北京', // 市
                receiver_county:'通州区', // 县/区
                receiver_address:'1', // 地址
                receiver_zip:'100102',
                receiver_name:'1', // 收件人姓名
                receiver_mobile:'1', // 收件人移动电话
                receiver_phone:'13900201001',
                request_ship_date:'',
                need_invoice:'0', // 是否需要发票
                invoice_name:'',
                invoice_content:'',
                payment:'',
                total_fee:'1',
                discount_fee:'',
                post_fee:'',
                need_card:'0', // 需要贺卡
                card_content:'',
                create_date:'',
                buyer_message:'买家留言',
                seller_memo:'卖家备注',
                skus: [
                        {
                          product_code: '6974138790000', // 条码
                          qty: '1', // 数量
                          payment: '1',
                          discount_fee: '1',
                          shop_id: '254776', // 店铺ID
                          owner_id: '340120', //  货主ID
                          sell_price: '1'
                        }
                ]
                }
              ]
        }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'pushTrades',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      ordercancel () {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            order_no: '10000000',
            remark: ''
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'cancelTrade',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      ordercancelbyorder (orderno) {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            order_no: orderno,
            remark: ''
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'cancelTrade',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.$message.info(JSON.stringify(res.data.data))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      orderstatequery () {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            order_no: '10000000'
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'tradeStatusQuery',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      fhquery () {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            order_no: '10000000'
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'tradeDeliverQuery',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      orderquerybyorder (orderno) {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            order_no: orderno
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'tradeDeliverQuery',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            window.console.log('已获取物流信息',res)
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
            if (that.resultstr.data.total_count !== null && that.resultstr.data.total_count !== undefined && that.resultstr.data.total_count !== '') {
              var pstmp = that.resultstr.data.trades[0].out_ids
              window.console.log(pstmp)
              that.stackquerybybase(pstmp)
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      orderquery () {
        var jsondata =
          {
            stock_id: '220126',
            shop_id: '254776',
            order_no: '10000000'
          }
        var qstr = {
          param_json: JSON.stringify(jsondata),
          v_method: 'tradeQuery',
          if_new: '1'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/runky',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      standquery () {
        that = this
        var jsondata = [
          {
            businessNo: 'JDVA15869244659',
            sellerNo: '010K1234567'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/standquery',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      pregetwaybillcodes () {
        that = this
        var jsondata = [
          {
            orderOrigin: 1,
            customerCode: '010K2559362',
            clinicCode: 'ID123',
            sum: 1
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/pregetwaybillcodes',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getjdstatus () {
        that = this
        var jsondata = [
          {
            waybillCode: 'JDVA13722949436',
            orderCode: 'EO0036166996239',
            orderOrigin: 1,
            customerCode: '010K2559362'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/getjdstatus',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getjdtrace () {
        that = this
        var jsondata = [
          {
            waybillCode: 'JDVA1234567890',
            orderCode: 'EO0036166996239',
            orderOrigin: 1,
            customerCode: '010K2559362'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/getjdtrace',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getgistrack () {
        that = this
        var jsondata = [
          {
            waybillCode: 'JDAZ03272555909',
            customerCode: '010K2559362'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/getgistrack',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      ordersdquery () {
        that = this
        var jsondata = [
          {
            customerCode: '010K2559362',
            deliveryId: 'JDV000000000000',
            phone: '2e65029dcb7a861b3f7d1098da6004be',
            dynamicTimeFlag: 0
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/ordersdquery',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      signaturequery () {
        that = this
        var jsondata = [
          {
            deliveryId: 'JDVA00000001',
            customerCode: '010K2559362'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/signaturequery',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      actualfeequery () {
        that = this
        var jsondata = [
          {
            waybillCode: 'JDVA13722949436',
            orderCode: 'EO0036166996239',
            orderOrigin: 1,
            customerCode: '010K2559362'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/actualfeequery',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getattachments () {
        that = this
        var jsondata = [
          {
            attachmentType: 1,
            orderOrigin: 1,
            waybillCode: 'JDVA13722949436',
            customerCode: '010K2559362',
            appKey: 'fh44ae4781e243d1bb2e065f8de53c70'
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/getattachments',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      editorder () {
        that = this
        var jsondata = [
          {
            orderId: 'LG202204141438',
            senderContact: {
              name: '李先生',
              mobile: '13188888888',
              phone: '010-88888888',
              fullAddress: '上海市青浦区香花桥街道崧复路xxx号',
              warehouseCode: 'WH001'
            },
            receiverContact: {
              name: '陈先生',
              mobile: '13188888888',
              phone: '010-88888888',
              fullAddress: '江苏省无锡市江阴市新桥镇北欧印象xx栋xxx号'
            },
            orderOrigin: '1',
            customerCode: '010K2559362',
            ownerNo: 'EBU******',
            productsReq: {
              productCode: 'ed-m-0001',
              productAttrs: {
                warmLayer: 'common'
              },
              addedProducts: [
                {
                  productCode: 'ed-a-0002',
                  productAttrs: {
                    guaranteeMoney: 672.11
                  }
                }
              ]
            },
            settleType: 3,
            cargoes: [
              {
                name: '服装',
                quantity: 1,
                weight: 1,
                volume: 100,
                length: 0,
                width: 0,
                hight: 0,
                remark: '请携带包装袋'
              }
            ],
            goods: [
              {
                name: '数据线',
                code: 'vb100084736325',
                amount: 100,
                quantity: 1,
                goodsAddProducts: [
                  {
                    productCode: 'ed-a-0015',
                    productAttrs: {
                      checkAttach: []
                    }
                  }
                ]
              }
            ],
            c2bAddedSettleTypeInfo: {
              basicFreigthSettleType: 1,
              packageServiceSettleType: 1,
              guaranteeMoneyServiceSettleType: 3
            },
            pickupStartTime: 1657675806000,
            pickupEndTime: 1657726206000,
            expectDeliveryStartTime: 1657726206000,
            expectDeliveryEndTime: 1657726206000,
            pickupType: 1,
            remark: '请轻拿轻放',
            CommonChannelInfo: {
              channelCode: '0030001',
              channelOrderCode: 238736283993
            },
            waybillCode: 'JDV123456789',
            extendProps: {
              autoSubscribe: 1
            }
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/jdorderedit',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      cancelorder () {
        that = this
        var jsondata = [
          {
            waybillCode: 'JDVA13722949436',
            orderCode: 'EO0036166996239',
            orderOrigin: 1,
            customerCode: '010K2559362',
            ownerNo: 'EBU******',
            cancelReason: '用户发起取消',
            cancelReasonCode: 1,
            cancelType: 1
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/jdordercancel',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      sendorder () {
        that = this
        var jsondata = [
          {
            orderId: 'LG202204141438',
            senderContact: {
              name: '李先生',
              mobile: '13188888888',
              phone: '010-88888888',
              fullAddress: '上海市青浦区香花桥街道崧复路xxx号',
              warehouseCode: 'WH001'
            },
            receiverContact: {
              name: '陈先生',
              mobile: '13188888888',
              phone: '010-88888888',
              fullAddress: '江苏省无锡市江阴市新桥镇北欧印象xx栋xxx号'
            },
            orderOrigin: '1',
            customerCode: '010K2559362',
            ownerNo: 'EBU******',
            productsReq: {
              productCode: 'ed-m-0001',
              productAttrs: {
                warmLayer: 'common'
              },
              addedProducts: [
                {
                  productCode: 'ed-a-0002',
                  productAttrs: {
                    guaranteeMoney: 672.11
                  }
                }
              ]
            },
            settleType: 3,
            cargoes: [
              {
                name: '服装',
                quantity: 1,
                weight: 1,
                volume: 100,
                length: 0,
                width: 0,
                hight: 0,
                remark: '请携带包装袋'
              }
            ],
            goods: [
              {
                name: '数据线',
                code: 'vb100084736325',
                amount: 100,
                quantity: 1,
                goodsAddProducts: [
                  {
                    productCode: 'ed-a-0015',
                    productAttrs: {
                      checkAttach: []
                    }
                  }
                ]
              }
            ],
            c2bAddedSettleTypeInfo: {
              basicFreigthSettleType: 1,
              packageServiceSettleType: 1,
              guaranteeMoneyServiceSettleType: 3
            },
            pickupStartTime: 1657675806000,
            pickupEndTime: 1657726206000,
            expectDeliveryStartTime: 1657726206000,
            expectDeliveryEndTime: 1657726206000,
            pickupType: 1,
            remark: '请轻拿轻放',
            CommonChannelInfo: {
              channelCode: '0030001',
              channelOrderCode: 238736283993
            },
            waybillCode: 'JDV123456789',
            extendProps: {
              autoSubscribe: 1
            }
          }
        ]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/jdordercreate',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      sendydd () {
        that = this
        var jsondata = [{
          senderContact: {
            name: '张先生',
            mobile: '13100000001',
            fullAddress: '江苏省苏州市高新区东渚镇美田里路xx号',
            warehouseCode: 'WH001'
          },
          receiverContact: {
            name: '李先生',
            mobile: '13100000001',
            fullAddress: '江苏省常州市新北区三井街道太湖明珠苑27-12号'
          },
          orderOrigin: 1,
          customerCode: '010K2559362',
          cargoes: [{
            name: '文件',
            quantity: 1,
            weight: 1,
            volume: 1,
            length: 1,
            width: 0,
            hight: 0,
            remark: '需要包装耗材'
          }],
          productsReq: {
            productCode: 'ed-m-0001',
            productAttrs: {
              warmLayer: 'common'
            },
            addedProducts: [{
              productCode: 'ed-a-0002',
              productAttrs: {
                guaranteeMoney: '100'
              }
            }]
          },
          goods: [{
            name: '数据线',
            code: 'vb100084736325',
            amount: '1.5',
            quantity: '2',
            serialNos: [{
              serialCode: 'SN-001-1'
            }],
            goodsAddProducts: [{
              productCode: 'ed-a-0015',
              productAttrs: {
                checkAttach: 'checkAttach_card'
              }
            }]
          }]
        }]
        var qstr = {
          accesstoken: that.accesstoken,
          param_json: JSON.stringify(jsondata),
          mode: '0'
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/precheck',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            that.resultstr = JSON.parse(JSON.parse(JSON.stringify(res.data.data)))
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      getaccess () {
        window.location = 'https://oauth.jdl.com/oauth/authorize?client_id=c233f7a52af14f80a688083435055f03&redirect_uri=urn:ietf:wg:oauth:2.0:oob&response_type=code'
      },
      getaccessinfo () {
        that = this
        var qstr = {
          whereinfo: ' id = 1',
          limit: '',
          sortinfo: ''
        }
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/querysfaccess',
          method: 'post',
          data: qstr,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.length > 0) {
              that.accesstoken = res.data[0].access_token
              that.todate = res.data[0].todate
            } else {
              that.accesstoken = []
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      },
      upaccess () {
        var adata = {
          sid: this.selwsitem.id.toString(),
          pid: this.selwsitem.spos.toString(),
          gid: this.curgid.toString(),
          gcount: this.ckcount.toString()
        }
        window.console.log(adata)
        that.$http({
          url: 'https://ecommapi.sqnetsoft.cn/addwsgoods',
          method: 'post',
          data: adata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.result === 'success') {
              that.$message({
                type: 'success',
                message: '库存更新成功!'
              })
              that.showpop = false
              that.querywsgoods()
            } else {
              that.$message({
                type: 'error',
                message: '库存更新失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ps/PsInfo.vue